import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FileUploadNG } from './file-upload-ng';
import * as util from './util';
import './product.css';
import './App.css';

import './common-form-components.css';

// ResearchsoftwareTextInfo
export class TextInfo extends Component {
  render() {
    return(
      <div className="TextInfo">
      <div className="prodHeaderTexts"> {this.props.heading}</div>
        <div className="CheckBoxContent Width100" dangerouslySetInnerHTML={{__html: this.props.content}} />
      </div>
    )
  }
}

//TextLine
export class TextLine extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state = {
      value: (this.props.value !== undefined ? this.props.value : ''),
      maxLength: this.props.maxLength ? this.props.maxLength : 400
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value && nextProps !== undefined) {
      this.setState({ value: nextProps.value });
    }
  }

  onChange(event) {
    var newValue = event.target.value;
    if (event.target.value.length <= this.state.maxLength) {
      this.setState({ value: newValue });
      this.props.update(this.props.slot, event.target.value);
    }
  }

  render() {
    return (
      <div className="TextLine prodHeaderTexts">
      <div className="prodHeaderTexts">  {this.props.obligatory === true ? '*' : null}{this.props.heading}
        <span className="bracketsText">{this.props.heading2}</span> </div>
        {this.props.subheading ? <p className="bracketsText"> {this.props.subheading} </p> : null}

      <div className="TextLineInput">
          <input  className="ProdInput" type="text" placeholder={this.props.placeholder} value={this.state.value} onChange={this.onChange} />
          <span style={{ fontSize: 'xx-small' }}>(noch {this.state.maxLength - this.state.value.length} Zeichen)</span>
      </div>
    </div>
    )
  }
}

//ResearchsoftwareTextField
export class TextField extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state = {
      value: (this.props.value !== undefined ? this.props.value : ''),
      maxLength: this.props.maxLength ? this.props.maxLength : 2000
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value && nextProps !== undefined) {
      this.setState({ value: nextProps.value });
    }
  }

  onChange(event) {
    var newValue = event.target.value;
    if (event.target.value.length <= this.state.maxLength) {
      this.setState({ value: newValue });
      this.props.update(this.props.slot, newValue);
    }
  }

  render() {
    return (
      <div className="TextField">
      <div className="prodHeaderTexts"> {this.props.obligatory === true ? '* ' : null}{this.props.heading}</div>
        <textarea className="ProdInput" placeholder={this.props.placeholder} value={this.state.value} maxLength={this.props.maxLength} size={this.props.maxLength} onChange={this.onChange} rows='6' cols='100' />
        <br /><span style={{ fontSize: 'xx-small' }}>(noch {this.state.maxLength - this.state.value.length} Zeichen)</span>
      </div>
    )
  }
}

//Price
export class Price extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state={value: (this.props.value !== undefined ? this.props.value : ''),
                maxLength: this.props.maxLength ? this.props.maxLength : 6,
                kostenfrei: (this.props.kostenfrei !== undefined ? this.props.kostenfrei : false) };

  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.value !== this.state.value && nextProps !== undefined) {
      this.setState({value: nextProps.value});
    }
  }

  onChange(event) {
    var newValue= event.target.value;

    if ( event.target.value.length === 0){
      newValue = "0";
    }

    // parseInt returns an integer and newvalue is String. We can not replace "==" with a "==="
    // eslint-disable-next-line eqeqeq
    if(event.target.value.length <= this.state.maxLength && (parseInt(newValue, 10) == newValue && (parseInt(newValue, 10) >= 0) ))

    {
      this.setState({value: newValue});
      this.props.update(this.props.slot, newValue);
    }
  }

  handleClick = (event) => {
    this.setState({ kostenfrei: !this.state.kostenfrei });
    this.setState({ value: "0"});
    this.props.update(this.props.slot, "0");
  }

  render() {
    return(
      <div className="Price">
        <div className="prodHeaderTexts"> {this.props.obligatory === true ? '* ' : null}{this.props.heading}
        {this.props.subheading ? <p className="bracketsText"> {this.props.subheading} </p> : null}</div>
        <div className="PriceDiv">
          <input type="checkbox" defaultChecked={this.state.kostenfrei} onChange={this.handleClick} />
          <label for="kostenfrei" style={{ fontFamily: 'Open Sans' }}>Kostenfrei</label>
          <br/>
          <input type="text" placeholder={this.props.placeholder} value={this.state.value} maxLength={this.props.maxLength} size={this.props.maxLength} onChange={this.onChange} disabled={this.state.kostenfrei} /> €
        </div>
        <br/><span style={{fontSize: 'xx-small'}}>(noch {this.state.maxLength - this.state.value.length} Zeichen)</span>
      </div>
    )
  }
}

//ResearchsoftwareInteger
export class IntegerField extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state={value: (this.props.value !== undefined ? this.props.value : ''),
                maxLength: this.props.maxLength ? this.props.maxLength : 20};
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.value !== this.state.value && nextProps.value !== undefined) {
      this.setState({value: nextProps.value});
    }
  }

  onChange(event) {
    if (event.target.value.length === 0){
      event.target.value = 0;
    }
    else {
      event.target.value =  event.target.value;
    }
    var newValue = event.target.value;

    if (newValue.length <= this.state.maxLength && (parseInt(newValue, 10) === newValue )) {
      this.setState({ value: event.target.value });
      this.props.update(this.props.slot, event.target.value);
    }
  }

  render() {
    return(
      <div className="Price">
      <div className="prodHeaderTexts"> {this.props.heading}
        {this.props.subheading ? <p className="bracketsText"> {this.props.subheading} </p> : null}</div>
        <div className="PriceDiv">
        <input type="text" title={this.props.placeholder} placeholder={this.props.placeholder} value={this.state.value} maxLength={this.props.maxLength} size={this.props.maxLength} onChange={this.onChange} />
        <br/><span style={{fontSize: 'xx-small'}}>(noch {this.state.maxLength - this.state.value.length} Zeichen)</span>
      </div>
      </div>
    )
  }
}

//ResearchsoftwareTags
export class Tags extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state={value: this.props.value,
                tags: [],
                error: false};
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.value !== this.state.value && nextProps !== undefined) {
      this.onChange(nextProps.value);
    }
  }

  componentDidMount() {
    this.onChange(this.props.value);
  }

  onChange(value) {
    this.setState({error: false});
    var newValue;
    if(value!== null) {
      newValue = value;
      document.getElementById('Tags'+this.props.match.params.id).innerHTML = value;
    } else {
      newValue = document.getElementById('Tags'+this.props.match.params.id).textContent;
    }
    var newTags = newValue.toString().split(/,/);
    newTags = newTags.filter( function(string) {
      return string.match(/\S/);
    });
    newTags = newTags.map(str => (str.replace(/^\s+/, '')).replace(/\s+$/, ''));
    if(newValue.length <= this.props.maxLength && newTags.length <= this.props.maxTags) {
      this.setState({value: newValue,
                     tags: newTags});
      this.props.update(this.props.slot, newValue);
    } else {
      document.getElementById('Tags'+this.props.match.params.id).innerHTML = this.state.value;
      alert('Zuviele Zeichen oder zuviele Tags/Stichworte!');
      this.setState({error: true});
    }
  }

  render() {
    return(
      <div className="Tags">
      <div className="prodHeaderTexts"> {this.props.obligatory === true ? '* ' : null}{this.props.heading}</div>
        <div className="TagsField" id={'Tags'+this.props.match.params.id} contentEditable='true' style={{backgroundColor: '#fcfdfe', color:'#3f3f3f'}} onKeyUp={event => this.onChange(null) } placeholder={this.props.placeholder} >
          <span>&zwnj;</span>
        </div>
        {this.state.error ? <div style={{color: '#7F0000'}}>Zuviele Zeichen oder Tags!</div> : null}
        <br/><span style={{fontSize: 'xx-small'}}>(noch {this.props.maxLength - this.state.value.length} Zeichen, noch {this.props.maxTags-this.state.tags.length} weitere Tags )</span>
      </div>
    )
  }
}

// ResearchsoftwareCheckBox
export class CheckBox extends Component {
  constructor(props) {
    super(props);
    this.onCheck = this.onCheck.bind(this);
    this.state={value: (this.props.value === true ? true : false)};
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.value !== this.state.value && nextProps !== undefined) {
      this.setState({value: nextProps.value});
    }
  }

  onCheck(event) {
    this.setState({value: !this.state.value});
    this.props.update(this.props.slot, !this.state.value);
  }

  render() {
    return (
      <div className="CheckBox openSans" id="downLanding">
        <div className="prodHeaderTexts"> {this.props.obligatory === true ? "" : null}{this.props.heading}</div>
          <div className="CheckBoxInputANDContent">
          <input className="CheckBoxInput" type="checkbox" checked={this.state.value} onChange={this.onCheck} />
          <span className="CheckBoxContent textAlign">  {this.props.content} </span>
          </div>
      </div>
    )
  }
}

//AGBCheckBox
export class AGBCheckBox extends Component {
  constructor(props) {
    super(props);
    this.onCheck = this.onCheck.bind(this);
    this.state={value: (this.props.value === true ? true : false)};
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.value !== this.state.value && nextProps !== undefined) {
      this.setState({value: nextProps.value});
    }
  }

  onCheck(event) {
    this.setState({value: !this.state.value});
    this.props.update(this.props.slot, !this.state.value);
  }

  render() {
    return (
      <div className="CheckBox openSans">
      <div className="prodHeaderTexts"> {this.props.obligatory === true ? "" : null}{this.props.heading}</div>
           <div className="CheckBoxInputANDContent">
          <input className="CheckBoxInput"type="checkbox" checked={this.state.value} onChange={this.onCheck}/>
        <span  className="CheckBoxContent textAlign">  {this.props.content1}<a href={this.props.agbUrl} download>{this.props.fileType}</a>{this.props.content2}</span>
        </div>
      </div>
    )
  }
}

//ResearchsoftwareSubmitButton
export class SubmitButton extends Component {
  constructor(props) {
    super(props);
    this.SaveForLater = this.SaveForLater.bind(this);
    this.SaveAndAnnounce = this.SaveAndAnnounce.bind(this);
  }
  
  SaveForLater(event) {
    event.preventDefault();
    this.props.onSubmit(false);
  }
  
  SaveAndAnnounce(event) {
    event.preventDefault();
    this.props.onSubmit(true);
  }
  
  render() {
    return (
      <div className="ColumnDisplay marginTop40">
        <div className="ToEndRight">
          <div className="button" onClick={this.SaveAndAnnounce}> Speichern und Veröffentlichen </div>
        </div>
        <div className="ToEndRight " onClick={this.SaveForLater}>
          <div className="button marginTop30"> Für später speichern </div>
        </div>
        <div className="ToEndRight " onClick={ () => window.confirm('Wirklich abbrechen? Nicht gespeicherte Einträge gehen verloren!') && this.props.history.replace('/product-list') } >
          <div className="button marginTop30"> Abbrechen </div>
        </div>
      </div>
    );
  }
}

//class ResearchsoftwareComplexityRate extends Component {
export class ComplexityRate extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state={value: this.props.value};
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.value !== this.state.value && nextProps.value !== undefined) {
      this.setState({value: nextProps.value});
    }
  }

  onChange(event) {
    this.setState({value: event.target.value});
    this.props.update(this.props.slot, event.target.value);
  }

  render() {
    return(
      <div className="ComplexityRate">
      <div className="prodHeaderTexts"> {this.props.obligatory === true ? '* ' : null}{this.props.heading}</div>
      <p className="bracketsText">{this.props.subheading} </p>
        <select value={this.state.value} onChange={this.onChange} >
          {this.props.complexityRate}
        </select>
      </div>
    )
  }
}

//ResearchsoftwareConfirmedText with textfield
export class ConfirmedText extends Component {
  constructor(props) {
    super(props);
    this.onChangeOnYes = this.onChangeOnYes.bind(this);
    this.onChangeOnNo = this.onChangeOnNo.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.state = {
      value: this.props.value,
      value2: (this.props.value2 !== undefined ? this.props.value2 : ''),
      maxLength: this.props.maxLength ? this.props.maxLength : 600
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value && nextProps.value !== undefined) {
      this.setState({ value: nextProps.value });
    }
    if (nextProps.value2 !== this.state.value2 && nextProps.value2 !== undefined) {
      this.setState({ value2: nextProps.value2 });
    }
  }

  onChangeOnYes(event) {
    this.setState({ value: true });
    this.props.update(this.props.slot, true);
  }

  onChangeOnNo(event) {
    this.setState({ value: false });
    this.props.update(this.props.slot, false);
  }

  handleInputChange(event) {
    var newValue = event.target.value;
    if (newValue.length <= this.state.maxLength) {
      this.setState({ value2: newValue });
      this.props.update(this.props.slot2, newValue);
    }
  }

  render() {
    return (
      <div className="ConfirmedText">
      <div className="prodHeaderTexts"> {this.props.obligatory === true ? '* ' : null}{this.props.heading}</div>
        <div className="YesNoText">
          <input type="radio" checked={this.state.value === true} onChange={this.onChangeOnYes} />
          <label> Ja </label>
          <input type="radio" checked={this.state.value === false} onChange={this.onChangeOnNo} />
          <label> Nein </label> <br /> <br />
        </div>
        <textarea className="ProdInput" placeholder={this.props.placeholder} value={this.state.value2} onChange={this.handleInputChange} rows='6' cols='100' />
        <br /><span style={{ fontSize: 'xx-small', fontFamily:'open sans' }}>(noch {this.state.maxLength - this.state.value2.length} Zeichen)</span>
      </div>
    )
  }
}

//ResearchsoftwareConfirmed  without TextField
export class Confirmed extends Component {
  constructor(props) {
    super(props);
    this.onChangeOnYes = this.onChangeOnYes.bind(this);
    this.onChangeOnNo = this.onChangeOnNo.bind(this);
    this.state = {
      value: this.props.value,
      maxLength: this.props.maxLength ? this.props.maxLength : 400
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value && nextProps.value !== undefined) {
      this.setState({ value: nextProps.value });
    }
  }

  onChangeOnYes(event) {
    this.setState({ value: true });
    this.props.update(this.props.slot, true);
  }

  onChangeOnNo(event) {
    this.setState({ value: false });
    this.props.update(this.props.slot, false);
  }

  render() {
    return (
      <div className="ConfirmedText">
      <div className="prodHeaderTexts"> {this.props.obligatory === true ? '* ' : null}{this.props.heading}</div>
        <div className="YesNoText">
          <input type="radio" checked={this.state.value === true} onChange={this.onChangeOnYes} />
          <label> Ja </label>
          <input type="radio" checked={this.state.value === false} onChange={this.onChangeOnNo} />
          <label> Nein </label> <br /> <br />
        </div>
      </div>
    )
  }
}

// yes/no and a Text-Field and a price-field
export class ConfirmedTextWithPrice extends Component {
  constructor(props) {
    super(props);
    this.onChangeOnYes = this.onChangeOnYes.bind(this);
    this.onChangeOnNo = this.onChangeOnNo.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputChange2 = this.handleInputChange2.bind(this);
    this.onChange = this.onChange.bind(this);
    this.state = {
      value: this.props.value,
      value2: (this.props.value2 !== undefined ? this.props.value2 : ''),
      value3: (this.props.value3 !== undefined ? this.props.value3 : ''),
      value4: (this.props.value4 !== undefined ? this.props.value4 : ''),
      maxLength1: this.props.maxLength ? this.props.maxLength : 600,
      maxLength2: this.props.maxLength ? this.props.maxLength : 6,

    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value && nextProps.value !== undefined) {
      this.setState({ value: nextProps.value });
    }
    if (nextProps.value2 !== this.state.value2 && nextProps.value2 !== undefined) {
      this.setState({ value2: nextProps.value2 });
    }
    if (nextProps.value3 !== this.state.value3 && nextProps !== undefined) {
      this.setState({ value3: nextProps.value3 });
    }
    if (nextProps.value4 !== this.state.value4 && nextProps !== undefined) {
      this.setState({ value4: nextProps.value4 });
    }
  }

  onChangeOnYes(event) {
    this.setState({ value: true });
    this.props.update(this.props.slot, true);
  }

  onChangeOnNo(event) {
    this.setState({ value: false });
    this.props.update(this.props.slot, false);
  }

  handleInputChange(event) {
    this.setState({ value2: event.target.value });
    this.props.update(this.props.slot2, event.target.value);

  }

  handleInputChange2(event) {
    var newValue = event.target.value;
    if (newValue.length <= this.state.maxLength1) {
      this.setState({ value4: newValue });
      this.props.update(this.props.slot4, newValue);
    }
  }

  onChange(event) {
    if (event.target.value.length === 0) {
      event.target.value = 0;
    }
    else {
      event.target.value = event.target.value;
    }
    var newValue = event.target.value;
    if (newValue.length <= this.state.maxLength2 && (parseInt(newValue, 10) === newValue) && (parseInt(newValue, 10) >= 0) ) {
      this.setState({ value3: event.target.value });
      this.props.update(this.props.slot3, event.target.value);
    }
  }

  render() {
    return (
      <div className="ConfirmedText">
      <div className="prodHeaderTexts"> {this.props.obligatory === true ? '* ' : null}{this.props.heading}</div>
        <div>
        <div className="YesNoText">
          <input type="radio" checked={this.state.value === true} onChange={this.onChangeOnYes} />
          <label> Ja </label>
          <input type="radio" checked={this.state.value === false} onChange={this.onChangeOnNo} />
          <label> Nein </label> <br /> <br />
          </div>
        </div>
        <div>
        <div className="prodHeaderTexts"> {this.props.heading2}</div>
        <div className="PriceDiv">
          <input type="text"  placeholder={this.props.placeholder} value={this.state.value3} maxLength={this.props.maxLength2} size={this.props.maxLength2} onChange={this.onChange} /> €
         </div>
          <span style={{ fontSize: 'xx-small' }}>(noch {this.state.maxLength2 - this.state.value3.length} Zeichen)</span>
        </div><br /><br />
        <textarea className="ProdInput" placeholder={this.props.placeholder} value={this.state.value4} onChange={this.handleInputChange2} rows='6' cols='100' />
        <br /><span style={{ fontSize: 'xx-small' }}>(noch {this.state.maxLength1 - this.state.value4.length} Zeichen)</span>
      </div>
    )
  }
}

//DocumentTypeSelection
export class Selection extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state={value: ''};
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.value !== this.state.value) {
      this.setState({value: nextProps.value});
    }
  }

  onChange(event) {
    this.setState({value: event.target.value});
    this.props.update(this.props.slot, event.target.value);
  }

  render() {
    return(
      <div className="Selection">
      <div className="prodHeaderTexts">  {this.props.obligatory === true ? '* ' : null}{this.props.heading}</div>
        <div className="SelectionValues">
          <select value={this.state.value} onChange={this.onChange} >
            {this.props.selectionValues}
          </select>
        </div>
      </div>
    )
  }
}

export class Duallistbox extends Component {
  constructor(props) {
    super(props);
    this.moveToRight = this.moveToRight.bind(this);
    this.moveToLeft = this.moveToLeft.bind(this);
    this.compare = this.compare.bind(this);
    this.selectByString = this.selectByString.bind(this);
    this.update = this.update.bind(this);
    this.fetchReferences = this.fetchReferences.bind(this);

    this.state = {
      options: [],
      selected: [],
      value: ''
    };
    this.fetchReferences();
  }

  fetchReferences() {
    fetch("/api/references", {
      headers: util.defaultHeaders()
    }).then(resp => resp.json())
      .catch(error => console.log("Fetching references error: ", error))
      .then(json =>
        this.setState({
          options: json.references.sort(this.compare),
          allOptions: json.references.sort(this.compare)
        }, () => this.selectByString(this.state.value))
      );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value && nextProps.value !== undefined) {
      this.setState({value: nextProps.value}, () => this.selectByString(nextProps.value));
    }
  }

  selectByString(value) {
    if(this.state.allOptions === undefined || this.state.allOptions.length === 0) {
      return true;
    }
    var valueArray = value.toString().split(/,/).filter(item => parseInt(item,10) === item);
    valueArray = valueArray.map( item => parseInt(item,10) );
    var options = [];
    var selected = [];
    this.state.allOptions.map( function(item) {
      return valueArray.indexOf(item.value) >= 0 ? selected.push(item) : options.push(item);
    });
    this.setState({options: options,
                   selected: selected});
    return true;
  }

  compare(a, b) {
    if (a.label.toLowerCase() < b.label.toLowerCase())
      return -1;
    if (a.label.toLowerCase() > b.label.toLowerCase())
      return 1;
    return 0;
  }

  update() {
    var references = '';
    var length = this.state.selected.length;
    for(var i=0; i<length; i++) {
      references = references.concat(this.state.selected[i].value.toString());
      if(i+1 < length) {
        references = references.concat(',');
      }
    }
    this.props.update(this.props.slot, references);
  }

  moveToRight(item) {
    var newOptions = this.state.options;
    var newSelected = this.state.selected;
    newOptions.splice(newOptions.indexOf(item), 1);
    newSelected.push(item);

    this.setState({
      options: newOptions,
      selected: newSelected
    }, () => this.update())
  }

  moveToLeft(item) {
    var newOptions = this.state.options;
    var newSelected = this.state.selected;

    newSelected.splice(newSelected.indexOf(item), 1);
    newOptions.push(item);

    this.setState({
      options: newOptions,
      selected: newSelected
    }, () => this.update());
  }

  render() {
    return (
      <div className="Duallistbox">
      <div className="prodHeaderTexts"> {this.props.heading}</div>
        <label className="InfoLabel" > Klicken Sie um zu verschieben. </label >
        <div className="LabelBox">
          <label className="Filter_left"> verfügbare Referenzen </label>
          <label className="Filter_right"> ausgewählte Referenzen </label>
        </div>
        <div className="DualList">
          <div className="DualListBox_left">
            <ul>
              {this.state.options.sort(this.compare).map(item => <li onClick={event => this.moveToRight(item)} key={item.value}>{item.label}<br/><br/></li>)}
            </ul>
          </div>
          <div className="DualListBox_right">
            <ul>
              {this.state.selected.sort(this.compare).map(item => <li onClick={event => this.moveToLeft(item)} key={item.value}>{item.label}<br/><br/></li>)}
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

export class PDFUpload extends Component {
  constructor(props) {
    super(props);
    this.onFinish = this.onFinish.bind(this);
    this.getFileInfo = this.getFileInfo.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.downloadLink = this.downloadLink.bind(this);

    this.state={value: this.props.value,
                fileName: null,
                uuid: null,
                finished: false};
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value && nextProps.value !== undefined) {
      this.getFileInfo(nextProps.value);
    }
  }

  getFileInfo(uuid) {
    var self = this;
    fetch(`/api/get-file-infos?uuids=${uuid}`, {
      headers: util.defaultHeaders()
    }).then(resp => resp.json())
      .catch(error => console.log("Could not get file infos. ", error))
      .then(function(json) {
        if(json !== undefined && json[0] !== undefined && json[0] !== null) {
          self.setState({
            fileName: json[0].fileName,
            uuid: json[0].uuid,
            finished: true
          })
        }
      });
  }

  onFinish(uuid) {
    this.props.update(this.props.slot, uuid);
    this.getFileInfo(uuid);
    return true;
  }

  onDelete() {
    this.setState({fileName: null,
                   finished: false
    });
    this.props.update(this.props.slot, null);
  }

  downloadLink() {
    return `${window.location.protocol}//${window.location.host}/${this.state.uuid}/${this.state.fileName}`;
  }

  render() {
    return(
      <div className="PDFUpload">
        {/*    <h3>{this.props.heading}</h3>
        {this.props.subheading}
        {this.state.finished ? <div style={{margin: '10px'}}><span style={{fontWeight: 'bold', color: 'green'}}>{this.state.fileName}</span> <span style={{color: 'red', cursor: 'pointer'}} onClick={ this.onDelete }> ✗ </span><span><Link to={this.downloadLink()} target="_blank"> ↓ </Link></span></div> : <FileUploadNG title="" onFinish={this.onFinish} onNewMessage={this.props.onNewMessage} />}
        */}
      </div>
    )
  }
}

export class MultipleFileUpload extends Component {
  constructor(props) {
    super(props);
    this.onFinish = this.onFinish.bind(this);
    this.getFileInfo = this.getFileInfo.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.downloadLink = this.downloadLink.bind(this);
    this.downloadElements = this.downloadElements.bind(this);

    var splitted = this.props.value.split(/,/);
    this.state={value: this.props.value,
                length: splitted.length,
                fileNames: splitted.map( item => null ),
                uuids: splitted.map( item => null ),
                finished: splitted.map( item => false )
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value && nextProps.value !== undefined) {
      this.getFileInfo(nextProps.value);
    }
  }

  getFileInfo(uuids) {
    var self = this;
    fetch(`/api/get-file-infos?uuids=${uuids}`, {
      headers: util.defaultHeaders()
    }).then(resp => resp.json())
      .catch(error => console.log("Could not get file infos. ", error))
      .then(function(json) {
        var length = json.length;
        var newFilenames = json.map( obj => (obj !== null) ? obj.fileName : null);
        var newUUIDs = json.map( obj => (obj !== null) ? obj.uuid : null );
        var newFinished = json.map( obj => (obj !== null && obj.fileName !== undefined) ? true : false );
        var newValue = '';
        for(var i=0; i<length; i++) {
          newValue = newValue.concat(newUUIDs[i] !== null ? newUUIDs[i].toString() : '');
          if(i+1<length) {
            newValue = newValue.concat(',');
          }
        }

        self.setState({
          value: newValue,
          length: length,
          fileNames: newFilenames,
          uuids: newUUIDs,
          finished: newFinished
        }, () => self.props.update(self.props.slot, self.state.value))
      });
  }

  onFinish(uuid, index) {
    var newUUIDs = this.state.uuids;
    newUUIDs[index] = uuid;
    this.getFileInfo(newUUIDs);
    return true;
  }

  onDelete(i) {
    var newUUIDs = this.state.uuids;
    newUUIDs[i] = null;
    this.getFileInfo(newUUIDs);
    return true;
  }

  downloadLink(i) {
    return `${window.location.protocol}//${window.location.host}/${this.state.uuids[i]}/${this.state.fileNames[i]}`;
  }

  downloadElements() {
    var self = this;
    return this.state.fileNames.map( function(fileName, i) {
      return (
        self.state.finished[i] ? <div key={i} style={{margin: '10px'}}><span style={{fontWeight: 'bold', color: '#1F6A81'}}>{i+1}. {fileName}</span><span style={{color: '#e50000', cursor: 'pointer',margin:'2%'}} onClick={ () => self.onDelete(i) }> ✗ </span><span><Link className="" to={self.downloadLink(i)} target="_blank"> ↓ </Link></span></div> : <FileUploadNG key={i} title="" onFinish={self.onFinish} index={i} onNewMessage={self.props.onNewMessage} />
      )
    })
  }

  render() {
    return(
      <div className="MultipleFileUpload">
      <div className="prodHeaderTexts"> {this.props.heading}</div>
      <span className="bracketsText"> {this.props.subheading}</span>
        {this.downloadElements()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common-form-components.js